module.exports = __webpack_public_path__ + "img/safety-green.ecfa6873.png";